import Vue from 'vue';
import Vuex from 'vuex';

import axios from 'axios';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

import buyout from './modules/buyout';
import orders from './modules/orders';
import statuses from './modules/statuses';
import refusals from './modules/refusals';

import * as modules from './modules';
import config from '../../config';

Vue.use(Donut);
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const isProduction = process.env.NODE_ENV === 'production';
const API_BASE = isProduction ? config.apiProd : config.apiDev;

export default new Vuex.Store({
  state: {
    apiKey: '',
    deviceTypes: [],
    manufacturersStore: [],
    shops: [],
    cities: [],
    lastUpdate: '',
    selectedFilters: {
      deviceTypeId: [],
      storeId: [],
      manufacturerId: []
    },
    changeDonuts: true,
    elasticInfo: [],
    datapickerInfo: [],
    sort: {
      value: '',
      key: ''
    },
    grade: [],
    gradeA: [],
    gradeB: [],
    gradeC: [],
    gradeD: [],
    otherManufacturerId: []
  },
  mutations: {
    SET_API_KEY(state, payload) {
      state.apiKey = payload;
      localStorage.setItem('apiKey',  state.apiKey);
    },
    GET_GRADE(state, payload) {
      state.grade = [];
      payload.map(element => {

        if (element === 'gradeA') {
          state.gradeA = [];

          let gradeA = state.elasticInfo.aggregations.Grade.buckets.filter(element => {
            return element.key === '0' || element.key === 'A' || element.key === '00' || element.key === '1' || element.key === 'Grade A';
          });
          gradeA.map(grade => {
            state.gradeA.push(grade.key);
          });

        } else if (element === 'gradeB') {
          state.gradeB = [];
          let gradeB = state.elasticInfo.aggregations.Grade.buckets.filter(element => {
            return element.key === '15' || element.key === '30' || element.key === 'B' || element.key === '2' || element.key === '3' || element.key === '35' || element.key === 'Grade B' || element.key === '35' || element.key === '35';
          });

          gradeB.map(grade => {
            state.gradeB.push(grade.key);
          });

        } else if (element === 'gradeC') {
          state.gradeC = [];
          let gradeC = state.elasticInfo.aggregations.Grade.buckets.filter(element => {
            return element.key === '45' || element.key === 'C' || element.key === '60' || element.key === '4' || element.key === '5' || element.key === '70' || element.key === 'Grade C';
          });

          gradeC.map(grade => {
            state.gradeC.push(grade.key);
          });

        } else if (element === 'gradeD') {
          state.gradeD = [];

          let gradeD = state.elasticInfo.aggregations.Grade.buckets.filter(element => {
            return element.key === '6' || element.key === '7' || element.key === '75' || element.key === '90' || element.key === '100' || element.key === 'D' || element.key === 'Grade D' || element.key === 'Grade E' || element.key === 'minPrice';
          });

          gradeD.map(grade => {
            state.gradeD.push(grade.key);
          });
        }
      });

      state.grade = state.grade.concat(payload);
    },
    setOtherManufacturerId(state) {
      let otherManufacturerArrayFirst = [];
      let otherManufacturerArraySecond = [];
      state.manufacturersStore.map(store => {
        otherManufacturerArrayFirst.push(store.id);
      });
      state.elasticInfo.aggregations.Manufacturer.buckets.map(store => {
        otherManufacturerArraySecond.push(store.key);
      });
      state.otherManufacturerId = otherManufacturerArraySecond.filter(e => otherManufacturerArrayFirst.findIndex(i => i === e) === -1);
    },
    setDatapicker(state, data) {
      state.datapickerInfo = data;
    },
    addDeviceTypeId(state, filters) {
      state.selectedFilters.deviceTypeId = filters;
    },
    addStoreId(state, filters) {
      state.selectedFilters.storeId = filters;
    },
    addManufacturerId(state, filters) {
      state.selectedFilters.manufacturerId = filters;
    },
    setSelect(state, payload) {
      state.deviceTypes = payload;
    },
    setManufacturers(state, payload) {
      state.manufacturersStore = payload;
      state.manufacturersStore.push({id: null, 'name': 'Другие'});
    },
    setShops(state, payload) {
      state.shops = payload;
    },
    setCities(state, payload) {
      state.cities = payload;
    },
    setLastUpdate(state, payload) {
      var d = new Date(payload),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear(),
          hour = '' + d.getHours(),
          minutes = '' + d.getMinutes();
      console.log(d.getTimezoneOffset())
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
      if (hour.length < 2) 
          hour = '0' + hour;
      if (minutes.length < 2) 
          minutes = '0' + minutes;
  
      // return [year, month, day].join('-');
      state.lastUpdate = [day, month, year].join('.') + " " + hour + ":" + minutes;
    },
    setSort(state, payload) {
      state.sort = payload;
    },
    changeDonuts(state) {
      state.changeDonuts = !state.changeDonuts;
    },
    setElasticInfo(state, payload) {
      state.elasticInfo = payload;
    }
  },
  actions: {
    GET_EXCEL() {
      document.querySelector('.loader-circle').classList.add('loader-circle_active');
      axios({
        method: 'post',
        url: `${API_BASE}/elastic/getXLSX`,
        headers: {'Authorization': `Bearer ${Vue.$storage.get('token')}`},
        data: {
          'params': {
            'date': this.state.datapickerInfo.length > 0 ? {
              'from': typeof this.state.datapickerInfo === 'string' ? this.state.datapickerInfo : this.state.datapickerInfo[0],
              'to': typeof this.state.datapickerInfo === 'string' ? this.state.datapickerInfo : this.state.datapickerInfo[1]
            } : null,
            'deviceType': this.state.selectedFilters.deviceTypeId && this.state.selectedFilters.deviceTypeId.length > 0 && !(this.state.selectedFilters.deviceTypeId.length == 1 && this.state.selectedFilters.deviceTypeId[0] == 0) ?
              {
                'DeviceTypeId': this.state.selectedFilters.deviceTypeId
              } : null,

            'store': this.state.selectedFilters.storeId && this.state.selectedFilters.storeId.length > 0 && !(this.state.selectedFilters.storeId.length == 1 && this.state.selectedFilters.storeId[0] == 0) ?
              {
                'StoreId': this.state.selectedFilters.storeId
              } : null,
            'manufacturer': this.state.selectedFilters.manufacturerId && this.state.selectedFilters.manufacturerId.length > 0 && !(this.state.selectedFilters.manufacturerId.length == 1 && this.state.selectedFilters.manufacturerId[0] == 0) ?
              {
                'ManufacturerId': this.state.selectedFilters.manufacturerId
              } : null
          }
        }
      })
        .then(response => {
          document.location.href = `${response.data.path}`;
        }).then(() => {
        document.querySelector('.loader-circle').classList.remove('loader-circle_active');
      });
    },
    GET_INFO_FILTER() {
      return axios({
        method: 'get',
        url: `${API_BASE}/elastic/getIdNames`,
        headers: {'Authorization': `Bearer ${Vue.$storage.get('token')}`}
      })
        .then(response => {
          response.data.deviceTypes.unshift({'id': 0, 'name': 'Все типы', 'selector': 'deviceType'});
          response.data.manufacturers.unshift({'id': 0, 'name': 'Все производители', 'selector': 'manufacturer'});
          response.data.cities.unshift({'id': 0, 'name': 'Все города', 'selector': 'cities'});
          response.data.stores.unshift({'id': 0, 'name': 'Все магазины', 'selector': 'store'});
          this.commit('setSelect', response.data.deviceTypes);
          this.commit('setManufacturers', response.data.manufacturers);
          this.commit('setShops', response.data.stores);
          this.commit('setCities', response.data.cities);
          this.commit('setLastUpdate', response.data.lastUpdate);
        })
    },
    SET_FILTER_VALUE() {
      return axios({
        method: 'post',
        // url: `${API_BASE}:9200/_search/template`,
        url: `https://elastic.tradein.telekominvest.com/kz-technodom/_search/template`,
        // headers: {'Authorization': 'ApiKey ZUdfYVZuTUJDQ3hWOFFGVnJUTXA6VUVVaVV6cXBUeDZrUFBxdlVWdzZqZw=='},
        headers: {'Authorization': `ApiKey ${localStorage.getItem('apiKey')}`},
        data: {
          'id': '2',
          'params': {
            'date': this.state.datapickerInfo.length > 0 ? {
              'from': typeof this.state.datapickerInfo === 'string' ? this.state.datapickerInfo : this.state.datapickerInfo[0],
              'to': typeof this.state.datapickerInfo === 'string' ? this.state.datapickerInfo : this.state.datapickerInfo[1]
            } : null,
            'deviceType': this.state.selectedFilters.deviceTypeId && this.state.selectedFilters.deviceTypeId.length > 0 && !(this.state.selectedFilters.deviceTypeId.length == 1 && this.state.selectedFilters.deviceTypeId[0] == 0) ?
              {
                'DeviceTypeId': this.state.selectedFilters.deviceTypeId
              } : null,

            'store': this.state.selectedFilters.storeId && this.state.selectedFilters.storeId.length > 0 && !(this.state.selectedFilters.storeId.length == 1 && this.state.selectedFilters.storeId[0] == 0) ?
              {
                'StoreId': this.state.selectedFilters.storeId
              } : null,
            'manufacturer': this.state.selectedFilters.manufacturerId && this.state.selectedFilters.manufacturerId.length > 0 && !(this.state.selectedFilters.manufacturerId.length == 1 && this.state.selectedFilters.manufacturerId[0] == 0) ?
              {
                'ManufacturerId': this.state.selectedFilters.manufacturerId
              } : null,
            sort: {
              key: this.state.sort.key ? this.state.sort.key : 'sum',
              value: this.state.sort.value ? this.state.sort.value : 'asc'
            },
            'gradeParam': this.state.grade && this.state.grade.length > 0 ? {
              Grade: this.state.grade
            } : null,
            'city': this.state.cities && this.state.cities.length > 0 && !(this.state.cities[0].id == 0) ? {
              CityId: this.state.cities
            } : null,

            // gradeParam: this.state.grade.length > 0 ? this.state.grade : null
          }
        }
      })
        .then(res => {
          this.commit('setElasticInfo', res.data);
          // this.state.elasticInfo = res.data;
        }).then(() => {
          this.commit('changeDonuts');
          // this.state.changeDonuts = !this.state.changeDonuts;
        });
    },

    SET_OTHER_MANUFACTURER() {
      return axios({
        method: 'get',
        url: `${API_BASE}/elastic/getIdNames`,
        headers: {'Authorization': `Bearer ${Vue.$storage.get('token')}`}
      })
        .then(response => {
          this.commit('setOtherManufacturerId', response.data.manufacturers);
        });
    }
  },
  modules: {
    buyout,
    orders,
    statuses,
    refusals,
    ...modules,
  },
  strict: debug,
});
